import { Link } from 'react-router';
import Heading from '@/components/Heading/Heading';
import PageShell from '@/components/PageShell';
import miaLogo from '@/assets/images/mia-logo-dark.svg';

const NotFoundPage = () => {
  return (
    <PageShell variant='single' className='about-us-page'>
      <div className='flex justify-center mb-4'>
        <img src={miaLogo} alt='Mia' className='' />
      </div>
      <Heading classes='text-2xl' align='center'>
        404 - Page Not Found
      </Heading>

      <p className='mb-4'>The page you are looking for cannot be found.</p>
      <p>
        <Link to='/' className='btn btn-primary mt-4 underline'>
          Go back to homepage
        </Link>
      </p>
    </PageShell>
  );
};

export default NotFoundPage;
